import { Autocomplete, TextField, CircularProgress } from '@mui/material';
import { Search } from 'lucide-react';

export interface Option {
  id: string;
  name: string;
}

interface FilterAutocompleteProps {
  label: string;
  options: Option[];
  optionFilter: Option | null;
  loading: boolean;
  onSelect: (option: Option | null) => void;
}

export function FilterAutocomplete({ label, options, loading, onSelect, optionFilter }: FilterAutocompleteProps) {
  return (
    <div className="w-full">
      <Autocomplete
        freeSolo={true}
        options={options}
        loading={loading}
        value={optionFilter}
        getOptionLabel={(option) => typeof option === "string" ? option : option.name}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        onInputChange={(_, value) => {
          onSelect(value ? { id: value, name: value } : null);
        }}        
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={label}
            variant="outlined"
            fullWidth
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <>
                  <Search className="w-5 h-5 text-gray-500 mr-2" />
                  {params.InputProps.startAdornment}
                </>
              ),
              endAdornment: (
                <>
                  {loading ? <CircularProgress color="inherit" size={20} /> : null}
                  {params.InputProps.endAdornment}
                </>
              ),
              className: "border border-gray-100 rounded-md bg-white",
              style: {
                color: 'black',
                WebkitTextFillColor: 'black',
              },
            }}
          />
        )}
        noOptionsText="No se encontraron resultados"
        loadingText="Cargando..."
        sx={{
          '& .MuiOutlinedInput-root': {
            height: '48px',
            borderRadius: '0.375rem',
            padding: '0 14px',
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: '#8284F3',
              borderWidth: '1px',
            },
          },
          '& .MuiAutocomplete-endAdornment': {
            right: '8px',
          },
          '& .MuiAutocomplete-inputRoot': {
            paddingTop: '0 !important',
            paddingBottom: '0 !important',
            display: 'flex',
            alignItems: 'center',
          },
          '& .MuiAutocomplete-input': {
            height: '40px',
            padding: '0 !important',
            color: 'black',
          }
        }}
      />
    </div>
  );
}
